(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cafe-feature"] && !Shopify.designMode) return;
  try {
    
/* No JS required; embeds handle themselves. */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cafe-logos"] && !Shopify.designMode) return;
  try {
    
/* none */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cafe-tiles"] && !Shopify.designMode) return;
  try {
    
/* No JS required */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cafe-video"] && !Shopify.designMode) return;
  try {
    
/* No JS required */

  } catch(e) { console.error(e); }
})();
})();
